class Works {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
      this.filterInit();
      this.paginateInit();
      this.urlParamInit();
    }
  }
  event(){
    $('.js-works-tab-container:nth-of-type(n + 2)').hide();

    const worksSwipers = [];

    $('.js-tab-trigger').click((e) => {
      const index = $(e.currentTarget).index();
      $(e.currentTarget).addClass("is-active").siblings().removeClass("is-active");
      $('.js-works-tab-container').hide();
      const tabContainer = $('.js-works-tab-container').eq(index);
      const progressFill = tabContainer.find(".js-works-swiper-progress-fill")[0];
      if (progressFill) {
        const totalSlides = parseInt(tabContainer.attr("data-works-slides") || "1", 10);
        progressFill.style.transition = "none";
        progressFill.style.width = `${(1 / totalSlides) * 100}%`;
        progressFill.offsetHeight;
        progressFill.style.transition = "";
      }
      const swiper = worksSwipers[index];
      if (swiper && swiper.update) {
        swiper.update();
        swiper.slideToLoop(0, 0);
      }
      tabContainer.fadeIn(400);
    });

    document.querySelectorAll(".js-works-swiper").forEach((el, index) => {
      const container = el.closest(".js-works-swiper-container");
      if (!container) return;
      const progressFill = container.querySelector(".js-works-swiper-progress-fill");
      const totalSlides = parseInt(el.dataset.count, 10) || el.querySelectorAll(".swiper-slide").length || 1;
      container.dataset.worksSlides = totalSlides;

      const prevBtn = container.querySelector(".js-works-swiper-prev");
      const nextBtn = container.querySelector(".js-works-swiper-next");
      const navArea = container.querySelector(".js-works-swiper-progress")?.closest(".flex");

      // 3件以下: 静止表示（Swiperなし）
      if (totalSlides <= 3) {
        el.classList.add('is-pickup-static');
        if (navArea) navArea.style.display = 'none';
        worksSwipers[index] = null;
        return;
      }

      // 4件以上: Swiper初期化
      const updateWorksProgress = (swiper) => {
        if (!progressFill) return;
        progressFill.style.width = `${swiper.progress * 100}%`;
      };

      const updateNavState = (swiper) => {
        if (prevBtn) prevBtn.classList.toggle('opacity-30', swiper.isBeginning);
        if (nextBtn) nextBtn.classList.toggle('opacity-30', swiper.isEnd);
      };

      const swiper = new Swiper(el, {
        slidesPerView: 1.4,
        speed: 500,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          768: {
            slidesPerView: 3.3,
          },
        },
        on: {
          init(swiper) {
            updateWorksProgress(swiper);
            updateNavState(swiper);
          },
          slideChangeTransitionStart(swiper) {
            updateWorksProgress(swiper);
            updateNavState(swiper);
          },
        },
      });
      worksSwipers[index] = swiper;
    });
  }
  paginateInit(){
    // PC: 9件/ページ（10件以上でページネーション表示）
    // SP: 8件/ページ（9件以上でページネーション表示）
    const getItemsPerPage = () => (window.innerWidth <= 767 ? 8 : 9);
    let currentPage = 1;
    const cards = [...document.querySelectorAll('.js-works-card')];
    const container = document.querySelector('.js-works-pagination');
    if (!container || cards.length === 0) return;

    cards.forEach(c => { if (!c.dataset.filtered) c.dataset.filtered = '1'; });

    const getFilteredCards = () => cards.filter(c => c.dataset.filtered !== '0');
    const getTotalPages    = () => Math.max(1, Math.ceil(getFilteredCards().length / getItemsPerPage()));

    const updateDisplay = () => {
      const perPage  = getItemsPerPage();
      const filtered = getFilteredCards();
      const total    = getTotalPages();
      if (currentPage > total) currentPage = total;
      const start = (currentPage - 1) * perPage;
      cards.forEach(card => {
        const idx = filtered.indexOf(card);
        card.style.display = (card.dataset.filtered === '0' || idx < start || idx >= start + perPage)
          ? 'none' : '';
      });

      // 件数表示更新
      const visibleCount = document.querySelector('.js-works-visible-count');
      const totalCount   = document.querySelector('.js-works-total-count');
      if (visibleCount) {
        const displayStart = filtered.length === 0 ? 0 : start + 1;
        const displayEnd   = Math.min(start + perPage, filtered.length);
        visibleCount.textContent = filtered.length === 0 ? '0' : `${displayStart}〜${displayEnd}`;
      }
      if (totalCount) totalCount.textContent = filtered.length;

      renderPagination(total);
    };

    const scrollToAnchor = () => {
      const anchor = document.querySelector('#anchor-works');
      if (!anchor) return;

      // ページネーション再描画でフォーカスが残ると、ブラウザが下部へ戻すことがある
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      // html { scroll-behavior: smooth } を一時的に無効化し、確実に即時移動する
      const root = document.documentElement;
      const prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      anchor.scrollIntoView({ block: 'start' });
      root.style.scrollBehavior = prevBehavior;
    };

    const goToPage = (page, { scroll = false } = {}) => {
      currentPage = Math.max(1, Math.min(page, getTotalPages()));
      updateDisplay();
      if (scroll) setTimeout(scrollToAnchor, 0);
    };

    this._goToPage = goToPage;

    // カードの表示切替による scroll anchoring がページ切替後のスクロールを打ち消すのを防ぐ
    const grid = document.querySelector('.js-works-grid');
    if (grid) grid.style.setProperty('overflow-anchor', 'none');

    const getPagesArray = (current, total) => {
      const range = [];
      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - 2 && i <= current + 2)) range.push(i);
      }
      const result = [];
      let prev = null;
      for (const p of range) {
        if (prev !== null && p - prev > 1) result.push('...');
        result.push(p);
        prev = p;
      }
      return result;
    };

    const arrowSvg = `<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const renderPagination = (total) => {
      if (total <= 1) { container.innerHTML = ''; return; }

      const pages       = getPagesArray(currentPage, total);
      const prevDisabled = currentPage === 1;
      const nextDisabled = currentPage === total;
      const btnBase     = 'w-[3.6rem] h-[3.6rem] rounded-full flex items-center justify-center font-bold duration-300';
      const arrowBase   = `${btnBase} bg-[#2A892C] text-white`;

      let html = '';

      html += `<button type="button" class="js-works-page-prev ${arrowBase} ${prevDisabled ? 'opacity-30 cursor-not-allowed' : 'pc:hover:opacity-70'}" ${prevDisabled ? 'disabled' : ''}>
        <span style="transform:scaleX(-1);display:flex;">${arrowSvg}</span>
      </button>`;

      for (const p of pages) {
        if (p === '...') {
          html += `<span class="w-[3.6rem] h-[3.6rem] flex items-center justify-center text-[1.4rem] text-[#888]">…</span>`;
        } else if (p === currentPage) {
          html += `<button type="button" class="js-works-page ${btnBase} text-[1.4rem] bg-[#2A892C] text-white" data-page="${p}">${p}</button>`;
        } else {
          html += `<button type="button" class="js-works-page ${btnBase} text-[1.4rem] bg-white text-[#333333] border border-[#CCCCCC] pc:hover:border-[#2A892C] pc:hover:text-[#2A892C]" data-page="${p}">${p}</button>`;
        }
      }

      html += `<button type="button" class="js-works-page-next ${arrowBase} ${nextDisabled ? 'opacity-30 cursor-not-allowed' : 'pc:hover:opacity-70'}" ${nextDisabled ? 'disabled' : ''}>
        ${arrowSvg}
      </button>`;

      container.innerHTML = html;

      container.querySelectorAll('.js-works-page[data-page]').forEach(btn => {
        btn.addEventListener('click', () => goToPage(parseInt(btn.dataset.page), { scroll: true }));
      });
      const prevBtn = container.querySelector('.js-works-page-prev');
      const nextBtn = container.querySelector('.js-works-page-next');
      if (prevBtn && !prevDisabled) prevBtn.addEventListener('click', () => goToPage(currentPage - 1, { scroll: true }));
      if (nextBtn && !nextDisabled) nextBtn.addEventListener('click', () => goToPage(currentPage + 1, { scroll: true }));
    };

    updateDisplay();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateDisplay, 150);
    });
  }
  urlParamInit(){
    const filterEl = document.querySelector('.js-works-filter');
    if (!filterEl) return;

    const urlParams = new URLSearchParams(window.location.search);
    const catParam  = urlParams.get('cat');
    if (!catParam) return;

    const slugs = catParam.split(',').map(s => s.trim());
    filterEl.querySelectorAll('.js-works-filter-checkbox').forEach(checkbox => {
      if (slugs.includes(checkbox.dataset.slug)) {
        checkbox.checked = true;
      }
    });

    if (this._applyFilter) this._applyFilter();

    const anchor = document.querySelector('#anchor-works');
    if (anchor) {
      setTimeout(() => {
        anchor.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }
  filterInit(){
    const filterEl      = document.querySelector('.js-works-filter');
    if (!filterEl) return;

    // SP アコーディオン
    const toggleEl = filterEl.querySelector('.js-works-filter-toggle');
    const bodyEl   = filterEl.querySelector('.js-works-filter-body');
    const iconEl   = filterEl.querySelector('.js-works-filter-icon');
    const isSP     = () => window.innerWidth <= 767;

    if (toggleEl && bodyEl) {
      if (isSP()) {
        bodyEl.classList.add('is-open');
        if (iconEl) iconEl.style.transform = 'translateX(-50%) rotate(90deg)';
      }

      toggleEl.addEventListener('click', () => {
        if (!isSP()) return;
        const isOpen = bodyEl.classList.contains('is-open');
        if (isOpen) {
          $(bodyEl).slideUp(300);
          bodyEl.classList.remove('is-open');
          if (iconEl) iconEl.style.transform = 'translateX(-50%)';
        } else {
          $(bodyEl).slideDown(300);
          bodyEl.classList.add('is-open');
          if (iconEl) iconEl.style.transform = 'translateX(-50%) rotate(90deg)';
        }
      });
    }

    const submitBtn = filterEl.querySelector('.js-works-filter-submit');
    const clearBtn  = filterEl.querySelector('.js-works-filter-clear');
    const cards     = document.querySelectorAll('.js-works-card');

    const applyFilter = () => {
      const checkedBusinesses = [...filterEl.querySelectorAll('input[name="business[]"]:checked')].map(el => el.value);
      const checkedCategories = [...filterEl.querySelectorAll('input[name="category[]"]:checked')].map(el => el.value);

      cards.forEach(card => {
        const business   = card.dataset.business;
        const categories = JSON.parse(card.dataset.categories || '[]');

        const matchBusiness = checkedBusinesses.length === 0 || checkedBusinesses.includes(business);
        const matchCategory = checkedCategories.length === 0 || checkedCategories.every(c => categories.includes(c));

        card.dataset.filtered = (matchBusiness && matchCategory) ? '1' : '0';
      });

      if (this._goToPage) this._goToPage(1);
    };

    this._applyFilter = applyFilter;

    submitBtn.addEventListener('click', applyFilter);

    clearBtn.addEventListener('click', () => {
      filterEl.querySelectorAll('.js-works-filter-checkbox').forEach(el => el.checked = false);
      cards.forEach(card => { card.dataset.filtered = '1'; });
      if (this._goToPage) this._goToPage(1);
    });
  }
}
